import { render, staticRenderFns } from "./print-icon.vue?vue&type=template&id=2cc135b8"
import script from "./print-icon.vue?vue&type=script&lang=js"
export * from "./print-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports